import { render, staticRenderFns } from "./MediaColumnLayout.vue?vue&type=template&id=37b9a52c&scoped=true&"
import script from "./MediaColumnLayout.vue?vue&type=script&lang=js&"
export * from "./MediaColumnLayout.vue?vue&type=script&lang=js&"
import style0 from "./MediaColumnLayout.vue?vue&type=style&index=0&id=37b9a52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9a52c",
  null
  
)

export default component.exports